var responsiveSizes = {
  mobile: {
    xxxl: {
      fontSize: '2.25rem',
      lineHeight: '2.5rem'
    },
    xxl: {
      fontSize: '1.875rem',
      lineHeight: '2.125rem'
    },
    xl: {
      fontSize: '1.5rem',
      lineHeight: '1.75rem'
    },
    l: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem'
    },
    m: {
      fontSize: '1.125rem',
      lineHeight: '1.375rem'
    },
    s: {
      fontSize: '1rem',
      lineHeight: '1.25rem'
    },
    xs: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem'
    },
    xxs: {
      fontSize: '0.8125rem',
      lineHeight: '1.0625rem'
    }
  },
  tablet: {
    xxxl: {
      fontSize: '2.25rem',
      lineHeight: '2.5rem'
    },
    xxl: {
      fontSize: '1.875rem',
      lineHeight: '2.125rem'
    },
    xl: {
      fontSize: '1.5rem',
      lineHeight: '1.75rem'
    },
    l: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem'
    },
    m: {
      fontSize: '1.125rem',
      lineHeight: '1.375rem'
    },
    s: {
      fontSize: '1rem',
      lineHeight: '1.25rem'
    },
    xs: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem'
    },
    xxs: {
      fontSize: '0.8125rem',
      lineHeight: '1.0625rem'
    }
  },
  desktop: {
    xxxl: {
      fontSize: '3.5rem',
      lineHeight: '3.75rem'
    },
    xxl: {
      fontSize: '2.25rem',
      lineHeight: '2.5rem'
    },
    xl: {
      fontSize: '1.875rem',
      lineHeight: '2.125rem'
    },
    l: {
      fontSize: '1.5rem',
      lineHeight: '1.75rem'
    },
    m: {
      fontSize: '1.25rem',
      lineHeight: '1.5rem'
    },
    s: {
      fontSize: '1.125rem',
      lineHeight: '1.375rem'
    },
    xs: {
      fontSize: '1rem',
      lineHeight: '1.25rem'
    },
    xxs: {
      fontSize: '0.875rem',
      lineHeight: '1.125rem'
    }
  }
};

export { responsiveSizes };
//# sourceMappingURL=responsiveSizes.js.map
